import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CreditNoteCreationPage } from '@/features/purchases/components/CreditNoteCreationPage';

const searchSchema = z.object({
  supplierId: z.number().optional(),
});

export const Route = createFileRoute('/$commiteeSlug/credit-notes/create')({
  validateSearch: searchSchema,
  component: CreditNoteCreationPage,
});
